module.exports = __webpack_public_path__ + "static/media/icon-person.b7b454c1.svg";